<script setup>
import MyGallery from '../Images/MyGallery.vue'

</script>

<template>
    <div class="container">
        <MyGallery />
    </div>
</template>
